/**
 * @typedef {object} StylesValue
 * @type {object}
 * @property {Object} background
 * @property {Object} nameAndLogo
 * @property {Object} border
 */

/** @type {StylesValue} */
export class InfographicEditStyles {
  background = {
    collectionID: null,
    bgID: null,
    opacity: 100,
    color: null,
    type: 'none'
  }
  nameAndLogo = {
    color: '#687782',
    opacity: 100,
    logoSize: '30x20',
    authorFontSize: 14,
    nameFontSize: 14,
    logoCollectionID: null,
    bgCollectionID: null,
    bgID: null,
    bgColor: null,
    type: 'none',
    showName: true
  }
  border = {
    line: 'solid',
    lineWidth: 1,
    shadow: 'none',
    color: '#2F4F4F'
  }

  constructor() {
    this.background = {
      collectionID: null,
      bgID: null,
      opacity: 100,
      color: null,
      type: 'none'
    }
    this.nameAndLogo = {
      color: '#687782',
      opacity: 100,
      logoSize: '30x20',
      authorFontSize: 14,
      nameFontSize: 20,
      logoCollectionID: null,
      bgCollectionID: null,
      bgID: null,
      bgColor: null,
      type: 'none',
      showName: true
    }
    this.border = {
      line: 'solid',
      lineWidth: 1,
      shadow: 'none',
      color: '#2F4F4F'
    }
  }
}
